import React from "react";
import InnerBanner from "../../components/InnerBanner";
import KeyServices from "../../components/KeyServices";

const Services = () => {
  return (
    <>
      <InnerBanner title="Services"/>
      <KeyServices container="default"/>
    </>
  );
};

export default Services;
